import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'sg-plaatjes-teksten',
  templateUrl: './plaatjes-teksten.component.html',
  styleUrls: ['./plaatjes-teksten.component.scss']
})
export class PlaatjesTekstenComponent{

  @Output() plaatjesTekstenChange = new EventEmitter();

  closePopover(){
    this.plaatjesTekstenChange.emit(null);
  }

  plaatjesTeksten = "Straf: je bent stout geweest. ga een beurt in de hoek staan\n" +
    "\n" +
    "Gepest: niet leuk…je wordt een beurt lang genegeerd door de anderen\n" +
    "\n" +
    "Meetlint: je hebt een groeispurt, ga 2 stappen vooruit\n" +
    "\n" +
    "Het gebroken hart: och…jouw hart is gebroken. Jouw leven heeft even geen zin meer, je hebt nergens zin in. Jammer 1 keer vanuit de grond van je hart en sla een beurt over.\n" +
    "\n" +
    "Glas bier: dikke kater, je blijft een dag in bed. Sla een beurt over\n" +
    "\n" +
    "De boom: je bent met je opgevoerde brommer tegen een boom gereden, je hebt de knal niet overleefd. Ga terug naar start. Reïncarneer en start het spel met een nieuw pionnetje \n" +
    "\n" +
    "Het instagram logo: och, je hebt een uur van je leven verspild aan social media, zonde. Maak een selfie met de groep (met duckface) en sla een beurt over.\n" +
    "\n" +
    "Het huis: je verlaat je ouderlijk huis en gaat zelfstandig wonen.  Doe iets wat je thuis nooit zomaar mocht doen\n" +
    "\n" +
    "Burn-out! Even pas op de plaats en erkennen dat je het alleen niet redt…je mag pas vooruit wanneer een ander je inhaalt.\n" +
    "\n" +
    "Telefoon: appen in het verkeer, levensgevaarlijk! lees je laatst ontvangen of verstuurde appje voor\n" +
    "\n" +
    "Millenial: jij bent de beste!! Jij kan alles aan! ga 49 vakjes vooruit! \n" +
    "\n" +
    "Foto buiten spel; je hebt alleen maar oog voor je carrière gehad. Jammer, je hebt daardoor van alles gemist van je geliefden. Doe 1 beurt lang een blinddoek op en zeg niets. Elke keer als je toch iets zegt komt er een beurt bij\n" +
    "\n" +
    "Baby: door de slapeloze nachten vanwege de baby (van de buren) heb je t gevoel dat de hele wereld doorgaat maar dat jij stilstaat…dat doe je dan ook 1 beurt. Alle anderen gaan 1 plekje vooruit\n" +
    "\n" +
    "Foto moeder Theresa: je mag een ander in nood helpen door het pionnetje van diegene op de eerst volgende ‘pak een kaart’ plek te plaatsen \n" +
    "\n" +
    "Het gras van de buren: je wil eigenlijk wel het leven van iemand anders…wissel van plek met 1 van je medespelers\n" +
    "\n" +
    "Vraagteken: jij mag drie vooruit of een ander 3 terug. Wat doe je? Voelt dit als de beste keuze..?\n" +
    "\n" +
    "Foto bierbuik: je wilt gezond leven en sport veel zodat je van de bierbuik afkomt. Verdikkeme, een blessure, iets rustiger aan doen: ga 2 vakjes terug en sta een beurt lang rechtop op 1 been\n" +
    "\n" +
    "foto Marijke Helwegen: wil je zó graag jonger zijn? Prima, ga 9 vakjes terug…\n" +
    "\n" +
    "foto: meno pauze: je hebt een opvlieger, ga 3 vakjes vooruit!\n" +
    "\n" +
    "Foto penopauze: op jacht naar een jonge vriendin. Wil je echt jonger zijn? Best, ga 12 vakjes terug\n" +
    "\n" +
    "Foto boeddha, je ervaart een verlichtingsmoment, voelt alleen maar liefde en leeft in het NU. Vertel iemand in de groep wat je aan diegene waardeert. Vervolgens ga je 3 beurten lang 1 vakje vooruit\n" +
    "\n" +
    "YES! Met pensioen! Eindelijk wat tijd voor wat echt belangrijk is. Schenk voor iedereen iets lekkers in\n" +
    "\n" +
    "Strand: wat ben je aan het genieten! Je kunt er geen genoeg van krijgen. Gooi nog een keer!\n" +
    "\n" +
    "ZZZ: je bent zo moe…ga een beurt lang met je hoofd op tafel liggen\n" +
    "\n" +
    "Hulp: het gaat lichamelijk steeds minder met je. Je hebt de komende 2 beurten bij alles wat je wilt eten, drinken en doen hulp nodig van de anderen (ga op je handen zitten voor de zekerheid)\n" +
    "\n" +
    "De denker: het gaat geestelijk steeds minder met je. Alles wat je de komende beurt zegt wordt niet begrepen door de anderen van de groep (anderen in de groep: leef je uit, gebruik je fantasie!)\n" +
    "\n" +
    "Mondje: wat voel je je eenzaam…zet de koptelefoon op en beluister het fragment (NB deze komt tussen deopdrachten in de app)\n" +
    "\n" +
    "Hoofdje met gum: je krijgt alzheimer en vergeet van alles…ga terug naar het vakje vóór het meetlint\n" +
    "\n" +
    "In de war! Ga naast de tafel staan, bal je vuisten en roep 3x: ‘daar heb je de russen!’. Blijf staan met je vuisten omhoog tot je weer aan de beurt bent\n" +
    "\n" +
    "Het allerlaatste vakje……ben je er klaar voor? Deel met de groep waar je het allermeest van hebt genoten in het leven. Kijk iedereen nog even goed aan, deel wat je nog te delen hebt en gooi de dobbelsteen. Mogelijk voor de allerlaatste keer… (ps als je 1 gooit ben je ‘er’, zo niet, dan ga je zoveel stapjes terug als de dobbelsteen aangeeft)\n"

}
